<template>
  <validation-observer ref="dataForm">
    <b-row>
      <b-col lg="6">
        <b-form-group
          id="input-group-1"
          :label="$t('quran_programs.program_name')"
          label-for="input-1"
        >
          <validation-provider
            #default="{ errors }"
            name="title"
            vid="title"
            rules="required"
          >
            <b-form-input
              id="input-1"
              v-model="newItem.title"
              type="text"
              :state="errors.length > 0 ? false : null"
              :placeholder="$t('quran_programs.program_name')"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group
          id="input-group-1"
          :label="$t('quran_programs.program_name_en')"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="newItem.title_en"
            type="text"
            :placeholder="$t('quran_programs.program_name_en')"
          />
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group
          id="input-group-30"
          :label="$t('edu_programs.explanation')"
          label-for="input-30"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('quran_programs.explanation')"
            vid="explanation"
            rules="required"
          >
            <ckeditor
              :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
              v-model="newItem.description"
              :placeholder="$t('edu_programs.explanation')"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <!-- .icon_path -->
      </b-col>
      <!-- .explanation -->
      <b-col lg="6">
        <b-form-group
          id="input-group-30"
          :label="$t('edu_programs.explanation_en')"
          label-for="input-30"
        >
          <ckeditor
            :config="{ contentsLangDirection: 'ltr',versionCheck : false }"
            v-model="newItem.description_en"
            :placeholder="$t('edu_programs.explanation_en')"
          />
        </b-form-group>
        <!-- .icon_path -->
      </b-col>
      <b-col lg="6">
        <b-form-group
          id="input-group-31"
          :label="$t('edu_programs.icon')"
          label-for="input-31"
        >
          <b-form-file
            id="wildcard"
            v-model="newItem.icon"
            accept="image/*"
            :placeholder="$t('edu_programs.icon')"
            @change="previewImage($event)"
          />
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-img
          v-if="newItem.icon_path"
          thumbnail
          fluid
          :src="newItem.icon_path"
          alt="Image 1"
        />
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
// import vSelect from "vue-select";

export default {
  components: {
    // vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: { newItem: Object },
  data() {
    return {
      // newItem: {},
    };
  },
  async created() {
    console.log( this.newItem);
  },
  methods: {
    async returnData() {
      const isValid = await this.$refs.dataForm.validate();
      console.log(isValid);
      if (!isValid) {
        return { valid: false };
      }
      return { valid: true, data: this.newItem };
    },
    previewImage(event) {
      console.log("event", event.target.files[0]);
      const _file = event.target.files[0];

      this.newItem.image = _file;
      this.newItem.icon_path = URL.createObjectURL(_file);
    },
  },
};
</script>

<style>
</style>